import React from "react";
import mapboxgl from "!mapbox-gl"; // eslint-disable-line import/no-webpack-loader-syntax
import "mapbox-gl/dist/mapbox-gl.css";
import * as turf from "@turf/turf";

mapboxgl.accessToken =
  "pk.eyJ1IjoiZW52aW9pZCIsImEiOiJja3g0bWx5NjgwN3MwMm9wYXB0cnpxdm43In0.F4GEDaOI0_o6fwWkL2r0lQ";

const MapManifestDetail = ({ legs }) => {
  const mapContainer = React.useRef(null);
  const map = React.useRef(null);
  // const [bounds, setBounds] = React.useState(null);

  React.useEffect(() => {
    if (map?.current) return;

    map.current = new mapboxgl.Map({
      container: mapContainer.current,
      style: "mapbox://styles/envioid/ckx5jzwyo23s714ob0srde3yk",
      center: [118.005351, -2.325613],
      zoom: 12,
      interactive: true,
    });
  }, []);

  const $reset = (key) => {
    const layer = map.current.getLayer(key);
    const source = map.current.getSource(key);
    if (typeof layer !== "undefined") {
      map.current.removeLayer(key);
    }

    if (typeof source !== "undefined") {
      map.current.removeSource(key);
    }
  };

  const makeLine = (curved, i) => {
    const key = `route-legs-${i}`;

    $reset(key);

    map?.current?.addSource(key, {
      type: "geojson",
      data: curved,
    });

    map?.current?.addLayer({
      id: key,
      source: key,
      type: "line",
      layout: {
        "line-cap": "round",
        "line-join": "round",
      },
      paint: {
        "line-width": 1,
        "line-color": "#848484",
        "line-dasharray": [3, 3, 3],
      },
    });
  };

  const MakeCurveLine = (origin, destination) => {
    const radius = turf?.rhumbDistance(origin, destination);
    const midpoint = turf?.midpoint(origin, destination);
    const bearing = turf?.rhumbBearing(origin, destination) - 90;

    const point = turf?.rhumbDestination(midpoint, radius, bearing);
    return turf?.lineArc(
      point,
      turf?.distance(point, origin),
      turf?.bearing(point, destination),
      turf?.bearing(point, origin),
      { steps: 200 }
    );
  };

  const setPoint = () => {
    if (!legs) return;

    let prevLoc = null;
    const bounds = new mapboxgl.LngLatBounds();
    legs?.forEach((leg, i) => {
      const point = [leg?.location?.longitude, leg?.location?.latitude];

      bounds.extend(point);
      new mapboxgl.Marker({
        scale: 0.5,
        color: leg?.type === "pickup" ? "#202020" : "#2f83ba",
      })
        .setLngLat(point)
        .addTo(map?.current);

      if (prevLoc) {
        makeLine(MakeCurveLine(prevLoc, point), leg?.id);
        prevLoc = point;
      } else {
        prevLoc = point;
      }
    });

    map.current.fitBounds(bounds, {
      maxZoom: 12,
      padding: 50,
    });
  };

  React.useEffect(() => {
    if (!map?.current) return;

    map?.current.on("load", () => {
      setPoint();
    });
  }, [legs]);

  React.useEffect(() => {
    if (!map?.current) return;
    reloadLegs();
  }, [legs]);

  const reloadLegs = () => {
    const check = map?.current.isStyleLoaded();

    if (!check) {
      setTimeout(function () {
        reloadLegs();
      }, 200);
      return;
    }

    setPoint();
  };

  return (
    <div>
      <div className="position-relative">
        <div style={{ marginLeft: -20, marginRight: -20 }}>
          <div ref={mapContainer} className="map-container-small" />
        </div>
      </div>
    </div>
  );
};

export default MapManifestDetail;
